/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react'
import { AppIcons } from '../../../../data/appIcons'

import { useNavigate } from 'react-router-dom'

/** Common Components */
import ToolbarButtons from '../../../../components/toolbarButtons/ToolbarButtons'
import Label from '../../../../components/finalForms/ui/label/Label'
import CustomCenterModel from '../../../../components/ui/customCenterModel/CustomCenterModel'
import FormInputFields from '../../../../components/finalForms/formFields/FormInputFields'
import Buttons from '../../../../components/ui/button/Buttons'
import ToastService from '../../../../services/toastService/ToastService'

/** Configuration files */
import { contractToolbarConfig, contractToolbarDeleteBtnConfig } from './Contract.toolbar.config'

/** RTK Query */
import { useDeleteContractMutation, useGetAllContractsListMutation, useUpdateContractMutation, useUpdateContractNameMutation } from '../../../../app/services/contractAPI'
import { ContractProvider } from '../../../../utils/context/ContractContext'
import { getDropdownValue } from '../../../../components/finalForms/libs/data/dropdownUtilities'
import SwalAlert from '../../../../services/swalService/SwalService'
import { useGetAllUsersSecurityGroupsListMutation } from '../../../../app/services/administrationAPI'
import { getCookie } from '../../../../utils/Cookies/CookieHandler'

/*Lazily Loaded Components*/
const ContractMaintenancetab = React.lazy(() => import('./ContractMaintenance.tab'));


const ContractMaintenance = () => {

  const url = window.location.search;
  const contractId = new URLSearchParams(url).get("contract");

  const { confirm, info } = SwalAlert();

  const cookie = getCookie("AuthUser");
  const userID = cookie?.user?.lUserKey;

  const navigate = useNavigate();
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [contractName, setContractName] = useState('');
  const [contractData, setContractData] = useState(null);
  const [isSaveClicked, setIsSaveClicked] = useState(false);

  const req = {
    pagination: {
      pageNumber: 1,
      pageSize: 99999,
    },
    plContractKey: contractId,
    plClientKey: 0,
    pbIncludeInactive: true,
  }

  const [getAllContractsList, {
    isSuccess: isAllContractsListFetched,
    data: AllAllContractsListData
  }] = useGetAllContractsListMutation();

  const [updateContractName, {
    isSuccess: isUpdateContractNamesuccess,
    data: updateContractNameData,
  },] = useUpdateContractNameMutation();

  const [updateContract, {
    isSuccess: isUpdateContract,
    data: updateContractData,
  },] = useUpdateContractMutation();

  const [getUserSecurityGroupList] = useGetAllUsersSecurityGroupsListMutation();

  const [deleteContract, {
    isSuccess: deleteContractDeleted,
    data: deleteContractData
  }] = useDeleteContractMutation();

  useEffect(() => {
    if(deleteContractDeleted && deleteContractData) {
      if (deleteContractData?.errorMessage?.includes("successfully")) {
        ToastService.success(deleteContractData?.errorMessage);
        navigate(`/Contracts`);
      }
      else {
        ToastService.error(deleteContractData?.errorMessage);
      }
    }
  }, [deleteContractDeleted, deleteContractData]);

  useEffect(() => {
    if (isUpdateContract && updateContractData) {
      if (updateContractData) {
        ToastService.success(updateContractData?.errorMessage);
        handleCloseClick();
      }
      else {
        ToastService.error("Something went wrong");
      }
    }
  }, [isUpdateContract, updateContractData]);

  useEffect(() => {
    if (contractId) {
      getAllContractsList(req);
    }
  }, [contractId]);

  useEffect(() => {
    if (isAllContractsListFetched && AllAllContractsListData) {
      setContractData(AllAllContractsListData?.dataSource[0]);
    }
  }, [isAllContractsListFetched, AllAllContractsListData]);

  useEffect(() => {
    if (isUpdateContractNamesuccess && updateContractNameData) {
      if (updateContractNameData) {
        ToastService.success(updateContractNameData?.errorMessage);
        handleCloseModel();
        getAllContractsList(req);
      }
      else {
        ToastService.error("Something went wrong");
      }
    }
  }, [isUpdateContractNamesuccess, updateContractNameData]);

  const handleRenameClick = () => {
    setIsModelOpen(true);
    setContractName(contractData?.contractName);
  };

  const handaleNameChange = (dataField, value) => {
    setContractName(value);
  }

  const handleCloseModel = () => {
    setIsModelOpen(!isModelOpen);
  };

  const handleCloseClick = () => {
    navigate(`/Contracts`);
  };


  const handleDelete = async () => {
    const req = {
      pagination: { pageNumber: 1, pageSize: 10000, },
      filters: { searchText: "" },
      plUserKey: userID,
      pbIncludeInactive: true
    }
    const response = await getUserSecurityGroupList(req);
    const groups = response?.dataSource || response?.data?.dataSource;
    const hasDeletePermission = groups.some(
      (group) =>
        group.securityGroup === "Administration" &&
        group.lUserKey === userID
    );
    if (!hasDeletePermission) {
      info(
        "You do not have permission to delete this contract.",
        "",
        "OK"
      );
      return;
    };
    const result = await confirm(
      "Are you sure you want to delete this contract?",
      "Do you wish to continue?",
      "Delete",
      "Cancel");
    if (result) {
        deleteContract(contractId);
    }
  };

  const handaleSave = () => {
    const req = {
      plContractKey: contractId,
      sContractName: contractName,
    };
    updateContractName(req);
  }

  const handleSaveClick = (data) => {
    setIsSaveClicked((prevState) => !prevState);
    if (data) {
      if (data?.dtOriginalTerminationDate) {
        if (data?.dtOriginalTerminationDate < data?.dtDateEffective) {
          ToastService.error("Original Termination Date cannot be less than Effective Date");
          return;
        }
      }
      if (data?.dtDateTermination < data?.dtDateEffective) {
        ToastService.error("Termination Date cannot be less than Effective Date");
        return;
      }
      if (data?.bCostsPerDepartment && data?.sPurchaseOrder.trim() === '') {
        ToastService.error("Purchase Order is required when Costs Per Department is enabled");
        return;
      }
      if (data?.billTypeEmail && (data?.sBillEmail ?? '').trim() === '') {
        ToastService.error("Billing Email is required when Bill Type is Email");
        return;
      }

      if (data?.bSharedRisk && data?.nSharedRiskPercentage <= 0) {
        ToastService.error("Shared Risk Percentage are required when Shared Risk Applicable is enabled");
        return;
      }

      const lBillType = data?.billTypeAddress && data?.billTypeEmail ? 3 : data?.billTypeAddress ? 1 : data?.billTypeEmail ? 2 : 0;

      const dtpDateEffective = new Date(data?.dtDateEffective);
      const lBillDay = dtpDateEffective.getDate();

      const request = {
        plContractKey: contractId,
        plSalesRepKey: getDropdownValue(data?.lSalesRepKey),
        plPaymentTermsKey: getDropdownValue(data?.lPaymentTermsKey),
        psContractName1: data?.sContractName1,
        psContractName2: data?.sContractName2,
        pdtDateEffective: data?.dtDateEffective,
        pdtDateTermination: data?.dtDateTermination,
        pAmtTotal: data?.dblAmtTotal,
        pAmtInvoiced: data?.dblAmtInvoiced,
        psContractAddr1: data?.sContractAddr1,
        psContractAddr2: data?.sContractAddr2,
        psContractCity: data?.sContractCity,
        psContractState: getDropdownValue(data?.sContractState),
        psContractZip: data?.sContractZip,
        psContractPhoneNumber: data?.sContractPhoneNumber,
        psPurchaseOrder: data?.sPurchaseOrder,
        plInstallmentTypeID: getDropdownValue(data?.lInstallmentTypeID),
        psBillEmail: data?.sBillEmail,
        psBillEmailName: data?.sBillEmailName,
        plBillType: lBillType,
        plBillDay: lBillDay,
        plSalesTaxKey: data?.bTaxExempt ? 0 : getDropdownValue(data?.lSalesTaxKey),
        pdtOriginalTerminationDate: data?.dtOriginalTerminationDate,
        plContractTypeKey: getDropdownValue(data?.lContractTypeKey),
        pbServicePlan: data?.bServicePlan,
        plServicePlanTermKey: data?.bServicePlan ? getDropdownValue(data?.lServicePlanTermKey) : 0,
        pbTaxExempt: data?.bTaxExempt,
        psContractShippingName1: data?.sContractShippingName1,
        psContractShippingName2: data?.sContractShippingName2,
        psContractShippingAddr1: data?.sContractShippingAddr1,
        psContractShippingAddr2: data?.sContractShippingAddr2,
        psContractShippingCity: data?.sContractShippingCity,
        psContractShippingState: getDropdownValue(data?.sContractShippingState),
        plContractShippingZip: data?.sContractShippingZip,
        psContractShippingPhoneNumber: data?.sContractShippingPhoneNumber,
        psContractShippingFaxNumber: String(data?.sContractShippingFaxNumber),
        pbShippingSameAsBilling: data?.bShippingSameAsBilling,
        pbShowShippingAddressOnInvoice: data?.bShowShippingAddressOnInvoice,
        pbSharedRisk: data?.bSharedRisk,
        pnSharedRiskPercentage: data?.nSharedRiskPercentage,
        pdtSharedRiskStartDate: data?.dtSharedRiskStartDate,
        pbManualSchedule: data?.bManualSchedule,
        pbCostsPerDepartment: data?.bCostsPerDepartment,
        pbUnlimitedProducts: data?.bUnlimitedProducts,
        pbShowConsumptionOnPortal: data?.pbShowConsumptionOnPortal,
        psContractFaxNumber: String(data?.sContractFaxNumber),
        pdtOriginalDateTermination: data?.dtOriginalTerminationDate,
      };
      
      updateContract(request);
    }
  };


  const handleActionClick = (action) => {
    switch (action) {
      case "SAVE":
        handleSaveClick();
        break;
      case "RENAME":
        handleRenameClick();
        break;
      case "CLOSE":
        handleCloseClick();
        break;
      case "DELETE":
        handleDelete();
        break;
      default:
        break;
    }
  };
  return (
    <div>
      <div className="row">
        <div className="col-12">
          <div className='top-action'>
            <div className='left-action-btns'>
              <ToolbarButtons
                toolbarConfiguration={contractToolbarConfig}
                onActionClick={handleActionClick}
              />
            </div>
            <div className='right-info-sec'>
              <Label labelName={`Contract :   ${contractData?.contractName ? contractData?.contractName : ''} `}></Label>
              <Label labelName={`Client :   ${contractData?.clientName ? contractData?.clientName : ''} `}></Label>
            </div>
          </div>
        </div>

      </div>
      <div className='contarct-maintenance-page mt-2'>
        <ContractProvider>
          <ContractMaintenancetab
            isClicked={isSaveClicked}
            onSaveClick={handleSaveClick}
          />
        </ContractProvider>

      </div>
      <div className="leftbottomsection-deletebtn">
        <ToolbarButtons
          toolbarConfiguration={contractToolbarDeleteBtnConfig}
          onActionClick={handleActionClick}
        />
      </div>
      <CustomCenterModel
        isOpen={isModelOpen}
        useCustomBg={true}
        modalTitle={"Edit Contract Name"}
        contentClass="content-35"
        onClose={handleCloseModel}
        modalTitleIcon={AppIcons.editIcon}
      >
        <FormInputFields
          dataField="contractName"
          value={contractName}
          labelName="Contract Name"
          isRequired={true}
          type="text"
          name="Enter Contract Name"
          onChange={handaleNameChange}
          error={contractName === '' ? 'Contract Name is required' : ''}
        />
        <div className="d-flex justify-content-center button-submit mt-3">
          <Buttons
            buttonText="Save"
            buttonTypeClassName="btn blue-btn w-full"
            onClick={handaleSave}
          // isDisable={!isEditContract}
          />
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="btn secondary-btn ml-4"
            onClick={handleCloseModel}
          />
        </div>
      </CustomCenterModel>

    </div>

  )
}
export default ContractMaintenance
